module.exports = __webpack_public_path__ + "static/media/pt6.cef8b430.jpg";